import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './CustomFalseCeiling.module.scss';
import { FalseCeilingSOW } from './CustomFalseCeilingConstants';
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import defaultImage from '../../../assets/default.png';

const CustomFalseCeilingSOW = (props: any) => {
  const max_col = 12;
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [customLightingArray, setCustomLightingArray] = useState([]);
  const [metaDataObj, setMetaDataObj] = useState(pageDetails?.metaData);

  useEffect(() => {
    let totalRow = max_col;

    // Checking if SC lighting data.
    if (pageDetails?.lightingDetails?.length) {

      // Reducing the custom options row based upon the SC lighting data
      totalRow = totalRow - (pageDetails?.lightingDetails?.length)
    }

    if (totalRow) {
      addCustomLightingOptions(totalRow);
    }

    setMetaDataObj(pageDetails?.metaData)
  }, [pageDetails])



  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  // Function to update custom Lighting options
  const addCustomLightingOptions = (no: any) => {
    const lightingArray = [];
    const optionsObject = FalseCeilingSOW?.summaryOptions;
    for (let i = 1; i <= no; i++) {
      const objId = `sow_custom_option_${i}`;
      lightingArray.push({ ...optionsObject, id: objId })
    }
    setCustomLightingArray(lightingArray);
  }

  // Component to show the options items
  const OptionView = (props: any) => {
    const { keyName, id, details } = props;
    const selectedObj = metaDataObj?.[id]?.[details?.id];
    return (
      !isDrawingsExporting ? <select className={style.edit_select_options} onChange={(v: any) => assignOptionValue(v.target.value, id, details, keyName)}>
        <option value=''></option>
        {
          details?.[keyName]?.map((e: any, i: any) => <option key={i} value={e} selected={selectedObj?.[keyName] === e}>{e}</option>)
        }
      </select> : <span>{selectedObj?.[keyName] || "-"}</span>
    )
  }

  // Function to update the specific options item.
  const assignOptionValue = (value, id, object, keyName) => {
    const optionObject = metaDataObj?.[id];
    const updatedObj = {
      ...metaDataObj,
      [id]: {
        ...metaDataObj?.[id],
        [object?.id]: {
          ...optionObject?.[object?.id],
          [keyName]: value
        }
      }
    }

    setMetaDataObj(updatedObj)
    updateItems(updatedObj)
  }

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...pageDetails,
      metaData: {
        ...pageDetails.metaData,
        ...details
      }
    };
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  return (
    <section className={style.ceiling_sow_section}>
      <h4 className="section_heading">Lighting & Electrical Details with Scope of Work</h4>
      <div className={style.ceiling_sow_table_container}>
        <div className={style.sow_summary_table_heading}>
          <p>Sub Category</p>
          <p>Product Type</p>
          <p>Product SKU</p>
          <p>Product Name</p>
          <p>Brand</p>
          <p>Wattage</p>
          <p>Size</p>
          <p>Qty</p>
          <p>Vender SKU</p>
          <p>Color Temp</p>
          <p>Image</p>
        </div>
        {
          pageDetails?.lightingDetails?.length ? <>
            <div className={style.sow_summary_table_view}>
              {
                pageDetails?.lightingDetails?.map((e, i) => {
                  let { name, imageUrl, subcategory, productType, productSku, brand, wattage, size, totalCount, vendorSku, colorTemp } = e;
                  return (
                    <>
                      <p>{subcategory || 'NA'}</p>
                      <p>{productType || 'NA'}</p>
                      <p>{productSku || 'NA'}</p>
                      <p>{name || 'NA'}</p>
                      <p>{brand || 'NA'}</p>
                      <p>{wattage || 'NA'}</p>
                      <p>{size || 'NA'}</p>
                      <p>{totalCount || 'NA'}</p>
                      <p>{vendorSku || 'NA'}</p>
                      <p>{colorTemp || 'NA'}</p>
                      <p>
                        <img alt="" crossOrigin="anonymous" src={imageUrl ? `${imageUrl.replace('https://prod.homelanestore.com', 'https://www.homelanestore.com')}?ver=${new Date().getTime()}` : defaultImage} width="40px" height="25px" />
                      </p>
                    </>
                  )
                }
                )}
            </div>
          </> : ''
        }
        <div className={`${style.sow_summary_table_view} ${pageDetails?.lightingDetails?.length ? style.HL_supply_section : ''}`}>
          {
            customLightingArray?.map((e, i) => <>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['subcategory'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['subcategory'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'subcategory')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['productType'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['productType'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'productType')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['productSku'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['productSku'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'productSku')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['name'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['name'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'name')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['brand'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['brand'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'brand')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['wattage'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['wattage'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'wattage')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['size'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['size'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'size')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['totalCount'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['totalCount'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'totalCount')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['vendorSku'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['vendorSku'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'vendorSku')} />}</p>
                <p>{isDrawingsExporting ? metaDataObj?.['customLightingOptions']?.[e?.id]?.['colorTemp'] : <input value={metaDataObj?.['customLightingOptions']?.[e?.id]?.['colorTemp'] || ''} className={style.edit_input_value} onChange={(v: any) => assignOptionValue(v.target.value, 'customLightingOptions', e, 'colorTemp')} />}</p>
                <p></p>
            </>)
          }
        </div>
      </div>
      {/* <div className={style.sow_electric_sow_tab}>
        {
          FalseCeilingSOW?.electricSOW?.map((e, i) => (
            <div className={`${style.electric_tab_options} ${style.grid_two_column}`}>
              <p>{e?.label}</p>
              <div className={style.grid_two_column}>
                {e?.typeName ? <OptionView keyName={'typeName'} details={e} id="electricScopeOfWork" /> : <span></span>}
                <OptionView keyName={'brand'} details={e} id="electricScopeOfWork" />
              </div>
            </div>
          ))
        }
      </div> */}
    </section>
  )
}

export default CustomFalseCeilingSOW;